module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-slide-vertical', [(_vm.visible) ? _c('div', {
    staticClass: "__panel",
    class: {
      wide: _vm.wide
    }
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('close', false)
      }
    }
  }), _c('div', {
    staticClass: "inner"
  }, [_vm._t("default")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d05950f","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panel/Popup.vue
// module id = a08d5899a9e3824b21ae
// module chunks = 0